import { connectCable, disconnectCable } from "@estaly/ui";
import { toCamelCase } from "@/utils/utils";

const CLAIM_INBOX_COUNTS = "claim_inbox_counts";

export default {
  namespaced: true,

  actions: {
    connect({ dispatch }) {
      connectCable({
        apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
        namespace: "bo",
        onMessage: (data) => dispatch("received", data),
        onConnected: () => dispatch("claims/fetchInboxCounts", null, { root: true }),
      });
    },

    disconnect() {
      disconnectCable();
    },

    received({ commit, dispatch }, data) {
      if (data.type === CLAIM_INBOX_COUNTS) {
        commit("claims/setInboxCounts", toCamelCase(data.counts), { root: true });
        return;
      }

      dispatch(
        "notifications/notify",
        { category: "simple", type: data.level || "info", title: data.title, text: data.message, path: data.path },
        { root: true },
      );
    },
  },
};
